const SCROLLED_STATE_CLASS = "scrolled"
const onScroll = () => {
  const scroll = document.documentElement.scrollTop;
  if (scroll > 140) {
    document.body.classList.add(SCROLLED_STATE_CLASS);
  } else if(scroll < 38) {
    
    document.body.classList.remove(SCROLLED_STATE_CLASS)
  }
}
window.addEventListener('scroll', onScroll)


jQuery(document).ready(function(){

  jQuery("#checklocal").click(function(e){
    e.preventDefault();
    jQuery('#zippy_widget_1511').toggle();
  });

});

jQuery(document).ready(function(){
jQuery('.wide-slider .multi-column').slick({
   dots: false,
   infinite: false,
   arrow:true,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 1400,
       settings: {
         slidesToShow: 2.2,
         slidesToScroll: 1,
         dots: false
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1.2,
         slidesToScroll: 1
       }
     }
   ]
 });
});

jQuery(document).ready(function(){
jQuery('.small-slider .multi-column').slick({
   dots: false,
   infinite: false,
   arrow:true,
   speed: 300,
   slidesToShow: 4.2,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 1600,
       settings: {
         slidesToShow: 3.2,
         slidesToScroll: 1,
         dots: false
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 2.2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 1.2,
         slidesToScroll: 1
       }
     }
   ]
 });
});

jQuery(document).ready(function(){
jQuery('#brand-slider').slick({
   dots: true,
   arrow:false,
   speed: 300,
   slidesToShow: 8,
   slidesToScroll: 8,
   responsive: [
     {
       breakpoint: 1600,
       settings: {
         slidesToShow: 6,
         slidesToScroll: 6,
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 4
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         dots: false,
         arrow:true,
       }
     }
   ]
 });
});

